<template>
  <el-form :model="shop" ref="shop">
    <div class="shop_container">
      <div>
        <el-form-item label="门头照片" label-width="78px">
          <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/shop'" :show-file-list="false"
                     :on-success="handleSuccess" :before-upload="beforeUpload">
            <img v-if="shop.factoryBrand" :src="$utils.imageSrc(shop.factoryBrand)">
            <el-icon v-else class="uploader_icon"><plus /></el-icon>
          </el-upload>
          <div class="tips"><i>建议尺寸：500 * 500</i></div>
        </el-form-item>
        <el-form-item label="门店名称" label-width="78px">
          <el-input type="text" v-model="shop.companyName"></el-input>
        </el-form-item>
        <el-form-item label="姓名" label-width="78px">
          <el-input type="text" v-model="shop.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="78px">
          <el-input type="number" v-model="shop.phone" readonly></el-input>
          <div class="tips"><i>敏感信息，暂不支持修改</i></div>
        </el-form-item>
        <el-form-item label="客服电话" label-width="78px">
          <el-input type="number" v-model="shop.servicePhone"></el-input>
        </el-form-item>
        <el-form-item label="地址" label-width="78px">
          <el-cascader ref="location" v-model="shopLocation" :props="shopLocations" @change="locationChangeHandler"></el-cascader>
          <el-input type="text" v-model="shop.address" @blur="getLbs" placeholder="**街道**号**座**室"></el-input>
        </el-form-item>
      </div>
      <div>
        <div id="map_container" style="height: 480px;"></div>
      </div>
    </div>
    <el-button type="primary" @click="saveShop">确定</el-button>
  </el-form>
</template>

<script>
let tencentMap, markerLayer

export default {
  name: "门店信息",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      shop: {},
      shopLocations: [],
      shopLocation: null
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file) {
      this.shop.factoryBrand = res.data
    },
    get() {
      this.$apis.shopMgr.get(this.currentUser.sn).then(response => {
        this.shop = response.data
        this.shopLocation = [this.shop.provinceCode, this.shop.cityCode, this.shop.countyCode]
        this.shop.expired = this.shop.factoryAuthEndTime == null || (new Date(this.shop.factoryAuthEndTime) - new Date()) / (3600000 * 24) <= 30
        this.$utils.setStorageObj('currentUser', this.shop)
        this.initMap()
      })
    },
    saveShop() {
      if (!this.shop.companyName) {
        this.$message.error('请输入门店名称')
        return
      }
      if (!this.shop.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.shop.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.shop.servicePhone) {
        this.$message.error('请输入客服电话')
        return
      }
      if (!this.shopLocation || !this.shop.address) {
        this.$message.error('请输入地址')
        return
      }
      this.$apis.shopMgr.edit(this.shop).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.get()
        }
      })
    },
    locationChangeHandler() {
      const node = this.$refs['location'].getCheckedNodes()
      this.shop.provinceCode = node[0].pathValues[0]
      this.shop.provinceName = node[0].pathLabels[0]
      this.shop.cityCode = node[0].pathValues[1]
      this.shop.cityName = node[0].pathLabels[1]
      this.shop.countyCode = node[0].pathValues[2]
      this.shop.countyName = node[0].pathLabels[2]
    },
    locationLazyLoad(node, resolve) {
      let _that = this
      if (node.level === 0) {
        _that.$apis.common.provinces().then(response => {
          const provinces = response.data
          let nodes = []
          provinces.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else if (node.level === 1) {
        _that.$apis.common.cities(node.value).then(response => {
          const cities = response.data
          let nodes = []
          cities.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else {
        _that.$apis.common.counties(node.value).then(response => {
          const counties = response.data
          let nodes = []
          counties.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: true
            })
          })
          resolve(nodes)
        })
      }
    },
    getLbs() {
      this.$apis.common.getLbs(this.shop.provinceName + (this.shop.cityName == this.shop.provinceName ? '' : this.shop.cityName) + this.shop.countyName + this.shop.address).then(response => {
        this.shop.lat = response.data[1]
        this.shop.lng = response.data[0]
        this.initMap()
      })
    },
    initMap() {
      console.log('初始化腾讯地图', tencentMap)
      let center = new TMap.LatLng(this.shop.lat, this.shop.lng)
      if (!tencentMap) {
        tencentMap = new TMap.Map('map_container', {
          zoom: 17, //设置地图缩放级别
          center: center //设置地图中心点坐标
        })
      } else {
        tencentMap.setCenter(center)
      }

      let markerGeo = {
        id: 'center',
        position: tencentMap.getCenter()
      }
      if (!markerLayer) {
        // 创建一个位于地图中心点的marker
        markerLayer = new TMap.MultiMarker({
          map: tencentMap,
          geometries: [
            markerGeo
          ]
        })
      } else {
        markerLayer.updateGeometries([markerGeo])
      }
      //监听地图平移
      let _that = this
      tencentMap.on("pan", () => {
        markerGeo.position = tencentMap.getCenter()
        markerLayer.updateGeometries([markerGeo])
        _that.shop.lat = markerGeo.position.lat
        _that.shop.lng = markerGeo.position.lng
      })
    }
  },
  created() {
    if (tencentMap) {
      tencentMap.destroy()
      tencentMap = null
      markerLayer = null
    }
    this.get()
    this.shopLocations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
  }
}
</script>

<style scoped>
.shop_container {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.shop_container>div:first-child {
  margin-right: 2%;
  width: 44%;
  min-width: 300px;
}
.shop_container>div:last-child {
  width: 54%;
  min-width: 300px;
}
</style>